import api from '@/servicos/api'

export default {
  listarTodos(body) {
    return api().post('/usuario/select', { idusuariotipo: 3 ,...body})
  },
  listarTodosQtde(body) {
      return api().post('/usuario/select/total', { idusuariotipo: 3 ,...body})
  },
  listar(id) {
    return api().post('/usuario/select', { idusuario: id })
  },
  buscar(query) {
    return api().post('/usuario/select', query)
  },
  status() {
    return api().get('/usuario/status')
  },
  atualizar(body) {
    return api().put('/usuario', body)
  }
}

